import styled from 'styled-components';

export const Container = styled.div`
  .p-inputtext:enabled:focus {
    outline: 0 none;
    outline-offset: 0;
    -webkit-box-shadow: 0 0 0 0em #8dcdff;
    -moz-box-shadow: 0 0 0 0em #8dcdff;
    box-shadow: 0 0 0 0em #8dcdff;
    border-color: ${({ theme, required }) =>
      required === true ? theme.colors.required : theme.colors.borderColor};
  }

  .p-inputtext:enabled:hover {
    /* border-width: 1.5px; */
    border-color: ${({ theme, required }) =>
      required === true ? theme.colors.required : theme.colors.borderColor};
  }

  .p-inputtext {
    border-color: ${({ theme }) => theme.colors.borderColor};
    font-size: 13px;
    font-family: ${({ theme }) => theme.fonts.regular};

    background: ${props => props.theme.colors.backgroundCard};
  }
  .required {
    border-color: ${({ theme }) => theme.colors.required};
  }
`;
